import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../components/Table/BasicTable.jsx";
import AddGRV from "./AddGRV.jsx";
import BreadCrumb from "../../../components/BreadCrumb.jsx";
import { InventoryApi } from "../../../apis/inventory.api.js";
import {
  columns,
  searchBy,
} from "../../../service/GRVInventoryService.js";
import ArticleModel from "../../Account/ArticleModel.jsx";

const GRV = ({ disabledFilters }) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const handlePagination = (data) => {
    console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      // copyfilter[]

      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const [selectedCell, ] = useState(null);
  const [ModalOpen, setModalOpen] = useState(false);
  const [editRolePermissions, setEditRolePermissions] = useState(null);
  const [allGrvData, setAllGrvData] = useState(null);
  const [isArticleOpen, setIsArticleOpen] = useState(false);
  const [description, setDescription] = useState(null);
  const getAllGRV = async () => {
    try {
      const res = await InventoryApi.getAllGRV(pagination, search);
      setAllGrvData(res?.data?.data);
    } catch (error) {
      console.log("Erorr", error);
    }
  };

  const closeRoleModal = () => {
    setModalOpen(false);
    setEditRolePermissions(null);
  };

  const handleCellClick = (cell, field = "") => {
    // console.log("cell", cell);
    if (field === "viewDetails") {
      setModalOpen(true);
      setEditRolePermissions(cell);
    } else if (field === "description") {
      setIsArticleOpen(true);
      setDescription(cell);
    }
    // else if (field === "viewDetails") {
    //   setModalOpen(true);
    //   setEditRolePermissions(cell);
    // }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    setSearch("");
    handlePagination && handlePagination(clearPagination);
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }
    handlePagination && handlePagination(data);
  };

  console.log("allGrvData", allGrvData);

  useEffect(() => {
    getAllGRV();
  }, [pagination, search]);

  console.log("description", description);

  return (
    <div className="p-5">
      <BreadCrumb title={"Goods Receipt Voucher"} />
      <BasicTable
        columns={columns}
        data={allGrvData?.goodReceiptVouchers || []}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: allGrvData?.limit || 5,
          rows: 5,
          sortField: null,
          sortOrder: null,
          totalPages: allGrvData?.totalPages || 1,
          totalCount: allGrvData?.totalCount || 1,
        }}
        onCellClick={(e) => console.log("Cell Data", e)}
        handleSearch={debouncedSearch}
        SearchBy={searchBy}
        // filters={filters}
        handleFilter={handleFilter}
        handleClearFilter={handleClearFilter}
        selectedData={selectedCell}
        handleCellClick={handleCellClick}
        button_name="Add GRV"
        handleButton={() => {
          setModalOpen(true);
        }}
      />
      <AddGRV
        data={editRolePermissions}
        open={ModalOpen}
        handleClose={closeRoleModal}
        getAllGRV={getAllGRV}
      />
      {isArticleOpen && (
        <ArticleModel
          data={description?.itemDetails?.[0]?.itemDescription}
          title="Description"
          onClose={() => setIsArticleOpen(false)}
        />
      )}
    </div>
  );
};

export default GRV;
